import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as Common from "./common";
import * as Forms from "./forms";

export const rootReducer = (
    state: StoreTypes.IStore,
    action: ActionGenerics.IAction<ActionTypes.Actions>
): StoreTypes.IStore => {
    return {
        initialSettings: state.initialSettings,
        common: Common.common(state.common, action),
        forms: Forms.forms(state.forms, action),
    };
};
